import React from "react";
import "../../styles/site-footer/footer.css";

const AvisoLegal = () => {
  return (
    <div
      className="modal fade vefrek-modal"
      id="avisoLegalModal"
      tabIndex="-1"
      aria-labelledby="avisoLegalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div>
              <h3 className="modal-title" id="avisoLegalLabel">
                AVISO LEGAL
              </h3>
              <div className="modal-subtitle-date">Última actualización: 18 de Junio de 2026</div>
            </div>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Cerrar"
            ></button>
          </div>
          <div className="modal-body">
            <div className="vefrek-modal-layout">


              {/* Columna Derecha: Contenido */}
              <div className="vefrek-modal-content-column">
                <section id="aviso-1" className="vefrek-modal-section">
                  <h3>1. Titularidad del Sitio</h3>
                  <p>
                    En cumplimiento de los deberes de información general establecidos en las normativas de servicios de la sociedad de la información, se hace constar que el titular de esta plataforma es:
                  </p>
                  <ul>
                    <li><strong>Titular:</strong> Biason Franco</li>
                    <li><strong>Email:</strong> administracion@vefrek.com.ar</li>
                    <li><strong>Domicilio:</strong> Río Gallegos, Santa Cruz, Patagonia Argentina</li>
                  </ul>
                </section>

                <section id="aviso-2" className="vefrek-modal-section">
                  <h3>2. Propiedad Intelectual</h3>
                  <p>
                    Todo el contenido presente en este sitio web, incluyendo pero no limitado a textos, imágenes, logotipos, gráficos, interfaces, código fuente, videos y diseños, está protegido por derechos de autor y otras leyes de propiedad intelectual de titularidad de Vefrek o de terceros que han autorizado su inclusión.
                  </p>
                  <p>
                    Queda estrictamente prohibido el uso no autorizado, reproducción, distribución o modificación de cualquier parte del contenido sin el consentimiento previo por escrito de su titular.
                  </p>
                </section>

                <section id="aviso-3" className="vefrek-modal-section">
                  <h3>3. Limitación de Responsabilidad</h3>
                  <p>
                    Vefrek se esfuerza por proporcionar información precisa y actualizada sobre los negocios y servicios automotores listados en el directorio. Sin embargo, no garantizamos la veracidad, integridad o actualidad de los datos proporcionados por terceros en sus respectivos perfiles.
                  </p>
                  <p>
                    No seremos responsables por ningún daño directo, indirecto, incidental, especial o consecuente que surja del uso o la imposibilidad de utilizar la plataforma, ni de los acuerdos comerciales y servicios contratados entre usuarios y las empresas publicitadas en este directorio.
                  </p>
                </section>

                <section id="aviso-4" className="vefrek-modal-section">
                  <h3>4. Enlaces a Terceros</h3>
                  <p>
                    Nuestro sitio web contiene enlaces a páginas web, redes sociales y plataformas de comunicación de terceros (como botones de WhatsApp o enlaces a sitios web de anunciantes). Estos enlaces se proporcionan únicamente para conveniencia del usuario.
                  </p>
                  <p>
                    No tenemos control sobre el contenido de dichos sitios web externos ni asumimos responsabilidad por la disponibilidad, seguridad o políticas de privacidad de los mismos.
                  </p>
                </section>

                <section id="aviso-5" className="vefrek-modal-section">
                  <h3>5. Jurisdicción y Ley Aplicable</h3>
                  <p>
                    Este Aviso Legal se rige e interpreta en su totalidad de acuerdo con las leyes vigentes en la República Argentina.
                  </p>
                  <p>
                    Cualquier controversia o disputa que surja en relación con el acceso, uso o interpretación de este sitio web estará sujeta a la jurisdicción exclusiva de los tribunales ordinarios de la ciudad de Río Gallegos, Provincia de Santa Cruz, con renuncia expresa a cualquier otro fuero que pudiera corresponder.
                  </p>
                </section>

                <section id="aviso-6" className="vefrek-modal-section">
                  <h3>6. Modificaciones</h3>
                  <p>
                    Nos reservamos el derecho de modificar o actualizar este Aviso Legal en cualquier momento para adaptarlo a cambios legislativos o novedades operativas de la plataforma. Las modificaciones tendrán vigencia de forma inmediata a partir de su publicación en el sitio web.
                  </p>
                  <p>
                    El uso continuo de la plataforma implica la aceptación plena de los términos vigentes. Si tiene dudas, contáctenos en administracion@vefrek.com.ar.
                  </p>
                </section>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Entendido
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvisoLegal;
